<template>
  <span class="information-btn">
    <el-button
      type="primary"
      @click="centerDialogVisible = true">
      Info
    </el-button>

    <el-dialog
      title="Collect Consent Info"
      :visible.sync="centerDialogVisible"
      :append-to-body="true"
      width="75%"
      custom-class="toolbar-info-dialog"
      center>
      <span>
        <!-- eslint-disable -->
        <p>
        <b>Definitions:</b><br>
          <ul>
            <li>JSON Editor: A display of raw data which is needed to display your text correctly on a webpage</li>
            <li>TEXT Editor: This is the editor that mocks a text editor like Pages or Microsoft Words</li>
            <li>Toolbar: The bar under the header with which you can perform actions</li>
            <li>Variables: In the toolbar is a drop-down menu with variables<sup>*</sup></li>
            <li>Html: Hypertext Markup Language, a standardised system for tagging text files to achieve font, colour, graphic, and hyperlink effects on web pages</li>
          </ul>
        </p>

        <hr>

        <p>
        <b>How to start editing text:</b><br>
        1. Select the country of the platform where the text will be shown <br>
        2. Select the language the text is for in the toolbar<br>
        3. Select the File you need in the toolbar<br>
        4. Now your screen will be filled with A JSON editor and in it text that already exists in the Database and you can start changing the content here.<br><br>
        Adviced is to only use this way for quick fixes the recommended way is using the Text Editor:<br><br>
        1. In the JSON editor click on the inputfield your text is in <br>
        2. In the toolbar click on the "editor" button <br>
        3. Now your Text Editor opens up <br>
        4. If you did NOT select an inputfield in the JSON editor you'll see the text:<br>
        "You need to choose an input field to work with"<br>
        At the bottom of the Text Editor
        </p>

        <hr>

        <p>
        <b>The lay-out of the JSON editor:</b><br>
        Once you have selected your country, file and language in the toolbar your JSON editor opens up and you may see the following fields:<br>
          <ul>
            <li>Consent title: This is the main title on the static page</li>
            <li>Consent Foreword: This is the text area directly under the Consent title</li>
            <li>The segments area: An overview of all the sub-titles and content of a page</li>
          </ul>
        Open up a segment with the arrow (>) button and you may see the following fields:<br>
        <sub>You don't want to hit the (X) button because it will permanently remove the segment!</sub>
          <ul>
            <li>Index: This field is needed in the DB, <span class="red"><u>DO NOT</u></span> change this.</li>
            <li>H1: This field is a main-title field so text in this field can be a heading of a subject mostly the H2 is used in segments</li>
            <li>H2: This field is a sub-title field so text in this field can be a heading of a new alinea or subject</li>
            <li>Summary: This is text directly under a subtitle and before the content. You can give a summary of the content that will follow</li>
            <li>Content: This field is used to write the content of the segment in the page or pop-up</li>
            <li>Checkboxes: A checked checkbox indicates that you will NOT use that option. Checking a checkbox will PERMANENTLY remove the text and will be lost when you save the file</li>
          </ul>
        </p>

        <hr>

        <p>
          <b>Adding Segments/Articles</b><br>
          THIS FEAUTRE IS NOT IN DEVELOPMENT AND IS NOT READY TO BE USED
        </p>

        <hr>

        <p>
        <b>How to save your new text:</b><br>
        1. Click on the "Save Text" button in the toolbar<br>
        2. A success message should become visible in the top right corner of your screen<br>
        3. Your text is now saved<br>
        4. You are changing live texts in a mather of minutes you should see the change on the websites<br>
        </p>

        <hr>

        <p>
          <b>Adding new countries & Languages</b><br>
          Ask the developers.
        </p>

        <hr>

        <p>
        <b>How to add variables:</b><br>
        <ul style="list-style: none;">
          <li><b>In the JSON editor</b></li><br>
          <li>
            <ul style="list-style: none;">
              <li>1. Make sure you are in the desired text area by clicking in the place where you want to add the variable</li>
              <li>2. Hover with your cursor over the arrow next to the variables button in the toolbar</li>
              <li>3. Click on the desired variable</li>
              <li>4. Your variable should now be pasted into the text at you cursor position</li>
            </ul>
          </li><br>
          <li><b>In the Text Editor</b></li><br>
          <li>
            <ul style="list-style: none;">
              <li>1. Open the variable dorpdown</li>
              <li>2. Click on the variable you want</li>
              <li>3. The variable is copied to your clipboard so:</li>
              <li>4. Paste it in the text where you want it</li>
            </ul>
          </li>
        </ul>
        </p>

        <hr>

        <p>
        <b>What is "Preview Text":</b><br>
        Here you can see a preview of what your text will look like.<br>
        Keep in mind that the styling of the text will mostly be done on the displaying website. <br>
        Use this preview to see if the lay-out of your created text is correct.
        </p>

        <hr>

        <p>
        <b>How to add styling to your text in the JSON editor:</b><br>
        <sub>Please only do this when you know what you are doing</sub><br><br>
        1. Bold text: surround you text with &#60;<span class="red">b</span>>&#60;<span class="red">/b</span>> for example:<br><br>
          &ensp;&ensp;&#60;<span class="red">b</span>>I’m Bold&#60;<span class="red">/b</span>> : <b>I'm Bold</b><br><br>
        2. Bullet list: surround your text with: &#60;<span class="red">ul</span>>&#60;<span class="red">li</span>>&#60;<span class="red">/li</span>>&#60;<span class="red">/ul</span>> for example:<br>
          &ensp;&ensp;&#60;<span class="red">ul</span>><br>
          &ensp;&ensp;&ensp;&ensp;&#60;<span class="red">li</span>>Item 1&#60;<span class="red">/li</span>><br>
          &ensp;&ensp;&ensp;&ensp;&#60;<span class="red">li</span>>Item 2&#60;<span class="red">/li</span>><br>
          &ensp;&ensp;&ensp;&ensp;&#60;<span class="red">li</span>>etc.&#60;<span class="red">/li</span>><br>
          &ensp;&ensp;&#60;<span class="red">/ul</span>><br>
          <ul>
            <li class="example">Item 1</li>
            <li class="example">Item 2</li>
            <li class="example">etc.</li>
          </ul>
        3.  Link to another page: use the following html: &#60;<span class="red">a</span> href=“/linktopage”>&#60;<span class="red">/a</span>> example:<br><br>
            &ensp;&ensp;&#60;<span class="red">a</span><span class="green"> href</span>=<span class="blue">“google.nl”</span>>this text links to google.nl&#60;<span class="red">/a</span>> : <a href=“google.nl”>this text links to google.nl</a><br><br>
        4.  Cursive text: surround your text with &#60;<span class="red">i</span>>&#60;<span class="red">/i</span>> for example:<br><br>
            &ensp;&ensp;&#60;<span class="red">i</span>>I’m cursive&#60;<span class="red">/i</span>> : <i>I’m cursive</i><br><br>
        5.  New line: You may have noticed the &#60;<span class="red">br</span>> in the text. This represents a new line.<br>
            &ensp;&ensp;You don’t need to type this and can just use the “enter/return” key on your keyboard.<br>
            &ensp;&ensp;After saving, the code will transform it in &#60;<span class="red">br</span>> tags. That is why you see them in existing text<br>
        </p>

        <hr>

        <p>
          <b><sup>*</sup>Variables:</b><br>
          Currently we have the following variables:
          <ul>
            <li>companyName: Google</li>
            <li>domainName: google.nl</li>
            <li>companyAddress1: street-name + number</li>
            <li>companyAddress2: Postcode + city</li>
            <li>companyAddress3: Country</li>
            <li>companyCocInfo: UK's Chamber of Comerce number</li>
            <li>CompanyVatInfo: VAT information</li>
            <li>launchYear: Year the website was launched</li>
            <li>currentYear: The year we life in</li>
            <li>modifiedDate: last time the legal-text/document was changed</li>
            <li>priceTable: Normal pricing table</li>
            <li>premiumPriceTable: Pricing table with premium prices</li>
            <li>transactionCost: Pricing per transaction</li>
            <li>partnerUrlAppend: A value appended to urls. Needed when reference to the partner should exist when routing</li>
          </ul>

          In your text a variabel will appear like this: <span v-pre>{{transactionCost}}</span><br>
          Do not remove the curly-braces: <span v-pre>{}</span><br>
          If you do, in this example, it will result in just showing the text: transactionCost, on the webpage
        </p>

        <hr>

        <p>
          <b>Questions?</b><br>
          You know where to go! :)
        </p>
      </span>
      <!-- eslint-enable -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">Close</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
export default {
  data() {
    return {
      centerDialogVisible: false,
    };
  },
};
</script>

<style lang="scss" scoped>
  .information-btn {
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 20px;
    padding: 3px 10px;
  }

  .toolbar-info-dialog {
    b, strong {
      font-weight: bolder;
      color: #000;
      font-size: 14px;
    }
    li {
      margin-left: -15px;

      &.example {
        line-height: 15px;
      }
    }
  }

  span {
    &.red {
      color: red;
    }
    &.blue {
      color:#0F9EFF;
    }
    &.green {
      color: #42b983;
    }
  }
</style>
